export const landingPages = 
    [
        {label: "webinar", value: "webinar"}, 
    ]